import React, { useState, useEffect } from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import HomeComponent from "./components/home/homeComponent";
import Navbar from "./components/navbar/Navbar";
import LoginModal from "./components/auth/login/LoginModal";
import DashboardComponent from "./components/dashboard/dashboardComponent";
import FooterComponent from "./components/footer/footer";
import SignupModal from "./components/auth/signup/SignupModal";
import ForgotPasswordModal from "./components/auth/forgotPassword/forgotPasswordModal";
import CoinPairComponent from "./components/coinPair/coinPair";
import HowItWorks from "./pages/howItWorks";
import FAQ from "./pages/faq";
import AboutUs from "./pages/aboutUs";
import ContactUs from "./pages/contactUs";
import Amlkyc from "./pages/amlKyc";
import ScrollToTop from "./components/ScrollToTop";
import PrivacyPage from "./pages/privacyPage";
import TermsOfUse from "./pages/termsOfUse";

const App = () => {
  const [auth, setAuth] = useState(null);
  const [role, setRole] = useState(null);
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [isLoginOpen, setLoginOpen] = useState(false);
  const [isSignupOpen, setSignupOpen] = useState(false);
  const [isDashboardNavbar, setIsDashboardNavbar] = useState(false);
  const [navText, setNavText] = useState("");
  const [isForgotPasswordOpen, setForgotPasswordOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userRole = localStorage.getItem("role");
    const userName1 = localStorage.getItem("userName");
    const email = localStorage.getItem("email");
    if (token) {
      setAuth(token);
      setRole(userRole);
      setUserName(userName1);
      setUserEmail(email);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("userName");
    localStorage.removeItem("email");
    setAuth(null);
    setRole(null);
    setUserName("");
    setUserEmail("");
  };

  return (
    <Router>
      <ScrollToTop />
      <Navbar
        auth={auth}
        setAuth={setAuth}
        onLoginClick={() => setLoginOpen(true)}
        onSignupClick={() => setSignupOpen(true)}
        userName={userName}
        userEmail={userEmail}
        onLogoutClick={handleLogout} // Pass handleLogout to Navbar
        isDashboardNavbar={isDashboardNavbar}
        navText={navText}
      />

      <Routes>
        <Route
          path="/"
          element={<HomeComponent onLoginClick={() => setLoginOpen(true)} />}
        />
        <Route
          path="/home"
          element={<HomeComponent onLoginClick={() => setLoginOpen(true)} />}
        />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/aml-kyc" element={<Amlkyc />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/privacy-policy" element={<PrivacyPage />} />

        <Route
          path="/coin/:crypto/:amount/:fiat/pair"
          element={
            <CoinPairComponent onLoginClick={() => setLoginOpen(true)} />
          }
        />
        <Route
          path="/dashboard"
          element={
            auth ? (
              <DashboardComponent
                role={role}
                onLogoutClick={handleLogout} // Pass handleLogout to Navbar
                setIsDashboardNavbar={setIsDashboardNavbar}
                setNavText={setNavText}
                navText={navText}
                setUserEmail={setUserEmail}
              />
            ) : (
              <h2>Please log in to view this page</h2>
            )
          }
        />
      </Routes>

      <LoginModal
        isOpen={isLoginOpen}
        onRequestClose={() => setLoginOpen(false)}
        onForgotPassword={() => {
          setLoginOpen(false);
          setForgotPasswordOpen(true);
        }}
        onSignupClick={() => {
          setLoginOpen(false);
          setSignupOpen(true);
        }}
        setAuth={setAuth}
        setRole={setRole}
        setUserName={setUserName}
        setUserEmail={setUserEmail}
      />
      <SignupModal
        isOpen={isSignupOpen}
        onRequestClose={() => setSignupOpen(false)}
        onLoginClick={() => {
          setSignupOpen(false);
          setLoginOpen(true);
        }}
        setAuth={setAuth}
        setRole={setRole}
      />

      <ForgotPasswordModal
        isOpen={isForgotPasswordOpen}
        onBackToLogin={() => {
          setForgotPasswordOpen(false);
          setLoginOpen(true);
        }}
        onRequestClose={() => setForgotPasswordOpen(false)}
      />

      <FooterComponent
        onLoginClick={() => setLoginOpen(true)}
        onSignupClick={() => setSignupOpen(true)}
        auth={auth}
      />
    </Router>
  );
};

export default App;
